import createVanilla from 'zustand/vanilla'
import { create } from 'zustand'

export interface InspectionLimitsState {
  limits: {
    files: {
      size: number
    }
    images: {
      extra: number
    }
    media: {
      duration: {
        audio: number
        video: number
      }
      size: {
        video: number
      }
    }
  }
  setLimits: (newState: InspectionLimitsState['limits']) => void
}

export const inspectionLimitsStore = createVanilla<InspectionLimitsState>(
  (set) => ({
    limits: {
      media: {
        duration: {
          audio: 120,
          video: 30,
        },
        size: {
          video: 100,
        },
      },
    },
    setLimits: (limits) => {
      set((state) => ({
        limits,
      }))
    },
  }),
)

export const useInspectionLimits = create(inspectionLimitsStore)
